<template>
  <v-row>
    <v-col>
      <div v-html="registrationText"></div>
    </v-col>
  </v-row>
  <v-row>
    <!-- Iterate over your array of branches -->
    <v-col v-for="branch in availableBranches" :key="branch.id" cols="12" md="6">
      <v-sheet class="border-opacity-25 overflow-hidden border-thin rounded-lg">
        <v-card
          :disabled="branch.branchYears[0].isFull()"
          :elevation="selectedBranchId === branch.id ? 12 : 2"
          @click="selectBranch(branch.id)">
          <v-card-title
            >{{ branch.name
            }}<v-icon
              v-if="selectedBranchId === branch.id"
              icon="mdi-check-circle"
              color="green"
              class="float-right"></v-icon
          ></v-card-title>
          <v-card-subtitle>{{ branch.branchLocation() }}</v-card-subtitle>
          <v-card-text>
            <div v-if="branch.branchYears[0].isFull()">
              Sorry the branch is full. Try the another location.
            </div>
            <v-progress-linear
              v-else="!branch.branchYears[0].isFull()"
              color="amber"
              :model-value="branch.branchYears[0].percentLeft()"
              height="25"
              bg-color="white">
              {{ branch.branchYears[0].numberLeft() }} Left</v-progress-linear
            >
            <div v-html="branch.bio"></div>
          </v-card-text>
        </v-card>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script setup lang="ts">
import { useYearStore } from '@/stores';
import { useBranchYearStore } from '@/stores/modules/admin';
import { computed } from 'vue';
interface Props {
  selectedBranchId: string | undefined;
}
const props = defineProps<Props>();

const selectedBranchId = computed(() => props.selectedBranchId);
const emit = defineEmits(['branchSelected']);
const yearStore = useYearStore();
const branchYearStore = useBranchYearStore();
const query = branchYearStore.getBranchesForYearQuery();
const availableBranches = computed(() => query.data.value?.data);
const registrationText = computed(() => {
  return yearStore.currentYear?.registration_text ?? '';
});

const selectBranch = (value: string) => {
  emit('branchSelected', value);
};
</script>
